import { Box, Container, Typography } from "@mui/material";
import React from "react";
import insomniahero from "../../images/insomniahero.png";

const styles = {
  parenBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
  },
  leftBox: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    gap: 3,
    flexWrap: "wrap",
  },
  rightBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    fontFamily: "poppins",
    fontWeight: "bold",
    lineHeight: 1.5,
    opacity: 0.7,
  },
  heroSubtitle: {
    fontFamily: "poppins",
    fontWeight: 600,
    opacity: 0.7,
  },
  button: {
    px: "10px",
    py: "5px",
    fontFamily: "poppins",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "#141414FF",
    color: "#ffffff",
  },
};

const InsomniaHero = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ ...styles.parenBox }}>
        <Box sx={{ ...styles.leftBox }}>
          <Typography
            variant="h4"
            textAlign={"start"}
            sx={{ ...styles.heroTitle }}
          >
            What is insomnia? <br />
            Causes, Cures, Remedies
          </Typography>
          <Typography
            variant="body1"
            textAlign="start"
            sx={{ ...styles.heroSubtitle }}
          >
            People with an abundance of money are luxurious, they have
            properties, but they are unable to buy sleep in their life. Today I
            will be talking about what is insomnia? What are the causes of
            insomnia? And how to cure insomnia.
          </Typography>
        </Box>

        <Box sx={{ ...styles.rightBox }}>
          <Box
            component="img"
            src={insomniahero}
            sx={{ width: "600px", heigh: "600px", borderRadius: "50px" }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default InsomniaHero;
